module.exports = __webpack_public_path__ + "static/media/company-placeholder.d1699c08.svg";